module.exports = __webpack_public_path__ + "img/car_shina2_35.8a5eac20.jpg";